import React, { useState } from "react";
import { View } from "react-native";

import { dailyChallengesService } from "../../services/DailyChallengesService";
import {
  restartPair,
  startDailyForDate,
  startDevPair,
  startSeedGame,
} from "../../dev/devGames";
import { Btn, Field, Note, Row } from "./controls";

/** New game by seed, a daily by date, any pair, or restart. */
const SetupSection: React.FC = () => {
  const [seed, setSeed] = useState("1");
  const [date, setDate] = useState(
    () =>
      dailyChallengesService.getTodaysChallenge()?.date ??
      new Date().toISOString().slice(0, 10),
  );
  const [start, setStart] = useState("");
  const [target, setTarget] = useState("");
  const [error, setError] = useState<string | null>(null);

  const act = async (f: () => Promise<string | null>) => setError(await f());

  return (
    <View>
      <Row>
        <Field
          testID="dev-seed"
          value={seed}
          onChange={setSeed}
          placeholder="seed"
          numeric
        />
        <Btn
          testID="dev-seed-go"
          label="New game with seed"
          onPress={() => act(() => startSeedGame(Number(seed)))}
        />
      </Row>
      <Row>
        <Field
          testID="dev-date"
          value={date}
          onChange={setDate}
          placeholder="YYYY-MM-DD"
        />
        <Btn
          testID="dev-daily-go"
          label="Play daily for date"
          onPress={() => act(() => startDailyForDate(date.trim()))}
        />
      </Row>
      <Row>
        <Field
          testID="dev-start"
          value={start}
          onChange={setStart}
          placeholder="start"
        />
        <Field
          testID="dev-target"
          value={target}
          onChange={setTarget}
          placeholder="target"
        />
        <Btn
          testID="dev-pair-go"
          label="Play pair"
          onPress={() => act(() => startDevPair(start, target))}
        />
      </Row>
      <Row wrap>
        <Btn
          testID="dev-restart"
          label="Restart this pair"
          onPress={() => act(restartPair)}
        />
      </Row>
      {error && <Note error>{error}</Note>}
    </View>
  );
};

export default SetupSection;
